import type { IconSvgObject } from './types';

const AcuteIcon: IconSvgObject = [
  ["path", { d: "M14 2L3 20H21M14 2L11 2.5M14 2L15 4.5M21 20L19 18M21 20L19 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.5 12.5028C10.3377 12.9839 12.5 14.9777 12.5 17.9818C12.5 18.6905 12.3797 19.3707 12.1586 20.0028", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AcuteIcon;
